import { Modal, Button } from "flowbite-react";
import CustomThemeModal from '../CustomThemes/CustomThemeModal';
import { HiOutlineExclamationCircle } from "react-icons/hi";

type CustomInfoModalPropType = {
    openModal: boolean,
    setOpenModal: (value: boolean) => void,
    message: string
}

const CustomInfoModal = ({openModal, setOpenModal, message}: CustomInfoModalPropType) => {

    return (
        <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup theme={CustomThemeModal}>              
            <Modal.Body>
                <div className="text-center">
                <HiOutlineExclamationCircle className="mx-auto mt-3 mb-4 text-gray-400 h-14 w-14 dark:text-gray-200" />
                <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                    {message}
                </h3>
                <div className="flex justify-center gap-4">
                    <Button color="gray" onClick={() => setOpenModal(false)}>
                    Close
                    </Button>
                </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default CustomInfoModal;
